import { render, staticRenderFns } from "./EventDashboard.vue?vue&type=template&id=1aa00733&"
import script from "./EventDashboard.vue?vue&type=script&lang=ts&"
export * from "./EventDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./EventDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports